import { useState, useEffect } from 'react';

function useProductDisplayMobility() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const handleResizeWithReset = () => {
      setWindowWidth(window.innerWidth);
    };
  
    window.addEventListener('resize', handleResizeWithReset);
  
    return () => window.removeEventListener('resize', handleResizeWithReset);
  }, []);

  useEffect(() => {
    // Move this logic into a useEffect to avoid infinite loops
    if(windowWidth > 768) {
      setDimensions({
        width: 250,
        height: 250,
      });
    } else if(windowWidth > 500) {
      setDimensions({
        width: 200,
        height: 200,
      });
    } else {
      setDimensions({
        width: 150,
        height: 150,
      });
    }
  }, [windowWidth]); // This effect depends on windowWidth

  return dimensions;
}

export default useProductDisplayMobility;